<canvas #canvas (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp($event)"
    (contextmenu)="$event.preventDefault();" [style.cursor]="cursorStyle"></canvas>